import { useEffect, useState } from 'react'
import { getWebinarCategories } from '@domain/features/webinars/webinars-feature'
import type { WebinarCategory } from '@domain/models/webinar'

export function useWebinarCategories(activeOnly = true) {
  const [categories, setCategories] = useState<WebinarCategory[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    setLoading(true)
    setError(null)

    async function load() {
      try {
        const result = await getWebinarCategories(activeOnly)
        if (!cancelled) {
          setCategories(result)
        }
      } catch (caughtError) {
        if (!cancelled) {
          setCategories([])
          setError(caughtError instanceof Error ? caughtError.message : 'Failed to load webinar categories.')
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    void load()
    return () => {
      cancelled = true
    }
  }, [activeOnly])

  return {
    categories,
    loading,
    error,
    hasCategories: categories.length > 0,
  }
}
